
import {baseUrl} from '@/api/api-list';
import {STATISTICS_URL} from '@/api/api-list';
import {loginStatusMixin} from '@/mixins/loginStatusMixin';
import {logoutMixin} from '@/mixins/logoutMixin';
import {routerMixin} from '@/mixins/routerMixin';
import {statistics} from "@/api/statistics";
import toolSoftwarePop from "@/components/header/toolSoftwarePop.vue";
import sdksPop from "@/components/header/sdksPop.vue";
import resolvePop from "@/components/header/resolvePop.vue";

export default {
  data() {
    return {
      baseUrl,
      STATISTICS_URL,
      menuHide: false,// 菜单的显示开关
      activeKey:''
    }
  },
  components: {
    toolSoftwarePop,
    sdksPop,
    resolvePop
  },
  mixins: [loginStatusMixin, logoutMixin, routerMixin],
  methods: {
    setActiveKey(){
      let pathname=location.pathname
      if(pathname.slice(-1)==='/'){
        pathname=pathname.slice(0, pathname.length-1)
      }
      let noKeyArr=['','/management','/speedtest']
      this.activeKey=''
      if(noKeyArr.includes(pathname)){
        return
      }
      this.menuList.forEach(item=>{
        if(item.children){
          item.children.forEach(itemC=>{
            if(itemC.children){
              itemC.children.forEach(itemCC=>{
                if (itemCC.path===pathname){
                  this.activeKey=item.key
                }
              })
            }else if (itemC.path===pathname){
              this.activeKey=item.key
            }
          })
        }else if(pathname===item.path){
          this.activeKey=item.key
        }
      })
    },
    gotoTestPage() {
      this.$router.push('/speedtest');
    },

    goHomePage() {
      this.$router.push('/');
    },
    goPage(item) {
      if (!item.children && item.path !== '/wifi') {
        statistics({
          position: item.statistics,
          type: 'click'
        })
        if (item.target) {
          window.open(item.path);
          return;
        }
        this.$router.push(item.path);
      }
    },
    // 登录
    login() {
      this.$store.commit('LOGIN_ALERT', true);
    },
    goToManagement() {
      this.$router.push('/management');
    }
  },
  watch:{
    '$route.path':{
      handler() {
        this.setActiveKey()
      },
      deep: true,
    }
  },
  mounted() {
    this.setActiveKey()
  },
}
